import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'

// components
import FaqInfo from './FaqInfo'
import PosInfo from './PosInfo'
import { HeaderTab } from '../../components'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'

const UseFaqPage = () => {
  const location = useLocation()

  const [allItems, setAllItems] = useState([])
  const [selectedItem, setSelectedItem] = useState([])

  const [manageType, setManageType] = useState(
    JSON.parse(localStorage.getItem('user'))?.manageType,
  ) //agent 사용여부

  const [headerLinks, setHeaderLinks] = useState([]) //tab 링크
  const [headerTitles, setHeaderTitles] = useState([]) //tab 제목

  const { fetchData, loading, data, error } = useAxios()

  useEffect(() => {
    //초기 진입 faq api 호출
    fetchData(constants.API.FAQ_LIST, 'GET', null, null)

    //페이지 진입시 맨 위로 화면 이동
    window.scrollTo(0, 0)
  }, [])

  const faqRoutes = [
    {
      path: '/usePos',
      selectedItems: 0,
      component: <PosInfo allItems={allItems?.posList} />,
    },
    {
      path: '/useFaq',
      selectedItems: 1,
      component: <FaqInfo allItems={allItems?.faqList} />,
    },
  ]

  //agent 사용여부
  useEffect(() => {
    if (manageType == '5') {
      //agent 사용 Y
      setHeaderTitles(['POS 주문프로그램', '사장님웹'])
      setHeaderLinks(['/usePos', '/useFaq'])
    } else {
      //agent 사용 N
      setHeaderTitles(['사장님웹'])
      setHeaderLinks(['/useFaq'])
    }
  }, [])

  // 페이지 진입 시 location.path에 따라 selectedItem  설정
  useEffect(() => {
    const matchingRoute = faqRoutes.find(
      (route) => route.path === location.pathname,
    )
    if (matchingRoute) {
      if (manageType != '5') {
        //사장님웹 tab active 설정
        setSelectedItem(0)
        return
      }
      setSelectedItem(matchingRoute.selectedItems)
    }
  }, [location.pathname])

  useEffect(() => {
    if (data?.responseCode === TYPE.API_RESPONSE.SUCCESS) {
      if (data?.responseData) {
        setAllItems(data.responseData)
      }
    }
  }, [data])

  return (
    <>
      <FaqWrap>
        <>
          <HeaderTab
            isDesktop={true}
            headerLinks={headerLinks}
            headerItem={headerTitles}
            selectedItem={selectedItem}
          />
          {manageType != 5 ? ( //agent 사용 N, 사장님웹 tab만 띄우기
            faqRoutes[1]?.component
          ) : (
            <>{faqRoutes[selectedItem]?.component}</>
          )}
        </>
      </FaqWrap>
    </>
  )
}

export default UseFaqPage

const FaqWrap = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
